import type { IconSvgObject } from './types';

const BrandfetchIcon: IconSvgObject = [
  ["path", { d: "M5 6.85746C10.5 2.42557 19 3.53936 19 7.52832C19 10.5665 11.5 12 11.5 12V12.2349C12.7814 12.22 17.5 12.0979 17.5 14.451C17.5 19.0482 8 17.8628 8 17.8628", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 8.5L7 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BrandfetchIcon;
